(() => {
  /**
   * Handle the multi modifier
   */
  class MultiModifier extends PIXI.Container {
    constructor() {
      super();

      this._ballSprite = null;
      this._multiBallEmitter = null;
      this.tempAnims = [];
      this.tempEmitters = [];
      this.shootingEmitterPool = [];
      this.shootingEmitterPoolLength = 0;
      this.tempMultipliers = {
        2: [],
        3: [],
        4: [],
        5: [],
      };
      this.shootingMultiplierPool = {
        2: [],
        3: [],
        4: [],
        5: [],
      };
      this.shootingMultiplierPoolLength = {
        2: 0,
        3: 0,
        4: 0,
        5: 0,
      };

      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    delay = (ms) => new Promise((res) => setTimeout(res, ms));

    /**
     * Initialise the class
     */
    initialise() {
      this._multiText = resourceManager.get("multiModifier:multiText");

      this._multiBallEmitter = particleManager.createEmitter(
        "throwParticleMagenta",
        "multiModifier:multiModifierContainer",
        0,
        -125,
        false
      );
      this._multiText.visible = false;
      this._multiBallEmitter.particleEmitter.spawnPos = { x: 0, y: 0 };
      this._multiBallEmitter.visible = false;
      this._multiBallEmitter.particleEmitter.emit = false;
    }

    /**
     * Grab the devil character spine assets
     */
    _onLayoutComplete() {}

    /**
     * Start the multi modifier
     */
    async start() {
      this._currentMultiplier = gameController.multiModifier.multiplier;
      gameController.centreDevil.fireBallIntro();
      this._multiText.visible = true;
      this._multiBallEmitter.visible = true;
      this._multiBallEmitter.particleEmitter.emit = true;

      this._multiText.texture = PIXI.Texture.from(
        `graphics/Generic/Symbols/Devil Symbols/Multiplier Values/x${this._currentMultiplier}.png`
      );

      await this.delay(1000);

      //create temp sprites and emitters
      for (let i = 0; i < gameController.collectableAwards.awards.length; i++) {
        const reel = helper.convertReelRowToIndex(
          gameController.collectableAwards.awards[i].collectable.coord.reel,
          gameController.collectableAwards.awards[i].collectable.coord.row
        );

        const symID = this.getSymbolID(gameController.collectableAwards.awards[i].collectable, this._currentMultiplier);
        const cash = gameController.collectableAwards.awards[i].collectable.type === "Cash";
        const shootingEmitter = this.getEmitterFromPool();
        this.tempEmitters.push(shootingEmitter);

        const shootingMultiplier = this.getShootingMultiplierFromPool();
        this.tempMultipliers[this._currentMultiplier].push(shootingMultiplier);

        if (i === gameController.collectableAwards.awards.length - 1) {
          this._multiBallEmitter.particleEmitter.emit = false;
          this._multiBallEmitter.visible = false;
          this._multiText.visible = false;
          gameController.centreDevil.idleLoop();
        }

        await this.shootParticleTween(shootingEmitter, reel, shootingMultiplier, cash, symID);
      }

      await new Promise((res) => gsap.delayedCall(1, res));
      //timerManager.addTimeout(1000, () => {
      this._reset();
      gameController.modifierComplete = true;
      //});
    }

    getSymbolID(collectable, multiplier) {
      if (collectable.type === "Gem") {
        switch (collectable.potName) {
          case "Mini":
            return 42 + multiplier;
          case "Minor":
            return 46 + multiplier;
          case "Major":
            return 50 + multiplier;
          case "Grand":
            return 54 + multiplier;
        }
      } else if ((collectable.type = "Cash")) {
        switch (collectable.amount) {
          case 50:
            return 22 + multiplier;
          case 150:
            return 26 + multiplier;
          case 250:
            return 30 + multiplier;
          case 100:
            return 34 + multiplier;
          case 200:
            return 48 + multiplier;
        }
      }
    }

    async shootParticleTween(emitter, reel, sprite, isCash, symID) {
      const coinText = resourceManager.get(`slotContainer:reelContainer:reel${reel}`);
      const reelObj = resourceManager.get("slotContainer:reelContainer:reel" + reel);
      const offset = isCash ? 0 : 45;
      return new Promise((resolve) => {
        const target = (obj) => {
          const globalPos = resourceManager.get(`slotContainer:reelContainer:reel${reel}:symbol0`).getGlobalPosition();
          const localPos = obj.parent.toLocal(globalPos);
          return { x: localPos.x, y: localPos.y };
        };

        const emitterTarget = target(emitter);
        const spriteTarget = target(sprite);

        const duration = 0.6;

        soundManager.stop("orbLoop");
        soundManager.play("orbWhoosh");
        gsap
          .timeline()
          .call(() => {
            emitter.x = 0;
            emitter.y = -125;
            emitter.particleEmitter.emit = true;
            emitter.visible = true;
          })
          .to(emitter, {
            duration,
            ease: "linear",
            y: emitterTarget.y + offset,
          })
          .to(
            emitter,
            {
              duration,
              ease: "linear",
              x: emitterTarget.x,
              onComplete: () => {
                emitter.particleEmitter.emit = false;
                emitter.visible = false;
                resolve();
              },
            },
            "<"
          );
        gsap
          .timeline()
          .call(() => {
            sprite.visible = true;
            sprite.x = 0;
            sprite.y = -125;
          })
          .to(sprite, {
            duration,
            ease: "linear",
            y: spriteTarget.y + offset,
          })
          .to(
            sprite,
            {
              duration,
              ease: "linear",
              x: spriteTarget.x,
              onComplete: () => {
                soundManager.play("orbLand");
                if (isCash) {
                  reelObj._multiplierTextOverlays[0].modifiedValue = this._currentMultiplier;
                  this.spinOffMultiplier(sprite);
                  coinText.multipliersActive = true;
                } else {
                  reelObj._multiplierOverlays[0].modifiedValue = this._currentMultiplier;
                  sprite.visible = false;
                }
              },
            },
            "<"
          );
      });
    }

    /**
     * Pulse the sprite on a gem symbol
     */
    spinOffMultiplier = function (sprite) {
      const duration = 1;
      gsap.to(sprite, {
        rotation: Math.PI * 4,
        alpha: 0,
        duration: duration,
        onComplete: () => {
          sprite.visible = false;
          sprite.alpha = 1;
        },
      });
      gsap.to(sprite.scale, {
        duration: duration,
        x: 2,
        y: 2,
        onComplete: () => {
          sprite.scale.x = 1;
          sprite.scale.y = 1;
        },
      });
    };

    /**
     * Pulse the sprite on a gem symbol
     */
    pulseSprite = function (sprite) {
      gsap.fromTo(
        sprite.scale,
        {
          x: 1,
          y: 1,
        },
        {
          duration: 0.5,
          x: 1.2,
          y: 1.2,
          yoyo: true,
          repeat: -1,
        }
      );
    };

    /**
     * Fetch a shooting Multiplier from the pool or create a new one
     */
    getShootingMultiplierFromPool = function () {
      let shootingMultiplier = undefined;

      if (this.shootingMultiplierPool[this._currentMultiplier].length > 0) {
        shootingMultiplier = this.shootingMultiplierPool[this._currentMultiplier].pop();
      } else {
        this.createShootingMultiplier();
        shootingMultiplier = this.shootingMultiplierPool[this._currentMultiplier].pop();
      }
      return shootingMultiplier;
    };

    /**
     * Fetch an emitter from the pool or create a new one
     */
    getEmitterFromPool = function () {
      let shootingEmitter = undefined;

      if (this.shootingEmitterPool.length > 0) {
        shootingEmitter = this.shootingEmitterPool.pop();
      } else {
        this.createShootingEmitter();
        shootingEmitter = this.shootingEmitterPool.pop();
      }
      return shootingEmitter;
    };

    /**
     * Create a shooting emitter
     */
    createShootingEmitter() {
      const emitter = particleManager.createEmitter(
        "throwParticleMagenta",
        "multiModifier:multiModifierContainer",
        0,
        -125,
        false
      );
      emitter.particleEmitter.spawnPos = { x: 0, y: 0 };
      emitter.particleEmitter.emit = true;
      emitter.visible = true;
      this.shootingEmitterPool.push(emitter);
    }

    /**
     * Create a shooting sprite.
     */
    createShootingMultiplier() {
      const shootingMultiplier = resourceManager.createObject(
        "sprite",
        "shootingMultiText:" +
          this._currentMultiplier +
          ":" +
          this.shootingMultiplierPoolLength[this._currentMultiplier],
        "multiModifier:multiModifierContainer",
        {
          fileName: `Symbols/Devil Symbols/Multiplier Values/x${this._currentMultiplier}.png`,
          anchor: 0.5,
          x: 0,
          y: -125,
        }
      );

      this.shootingMultiplierPoolLength[this._currentMultiplier]++;
      this.shootingMultiplierPool[this._currentMultiplier].push(shootingMultiplier);
    }

    /**
     * Reset all state
     */
    _reset() {
      this.tempEmitters.forEach((anim) => {
        this.shootingEmitterPool.push(anim);
      });
      while (this.tempEmitters.length) {
        this.tempEmitters.shift();
      }

      for (const [key, value] of Object.entries(this.tempMultipliers)) {
        value.forEach((sprite) => {
          this.shootingMultiplierPool[key].push(sprite);
        });
        while (value.length) {
          value.shift();
        }
      }
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "multiModifier",
    () => new MultiModifier(),
    () => {},
    () => []
  );
})();
